var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogsColored(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6702 7.89473C21.0302 5.72473 19.2202 3.91473 17.0502 3.27473C15.4002 2.79473 14.2602 2.83473 13.4702 3.42473C12.5202 4.13473 12.4102 5.41473 12.4102 6.32473V8.81473C12.4102 11.2747 13.5302 12.5247 15.7302 12.5247H18.6002C19.5002 12.5247 20.7902 12.4147 21.5002 11.4647C22.1102 10.6847 22.1602 9.54473 21.6702 7.89473Z",
    fill: "#4B4AD5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9099 14.3045C18.6499 14.0045 18.2699 13.8345 17.8799 13.8345H14.2999C12.5399 13.8345 11.1099 12.4045 11.1099 10.6445V7.06449C11.1099 6.67449 10.9399 6.29449 10.6399 6.03449C10.3499 5.77449 9.9499 5.65449 9.5699 5.70449C7.2199 6.00449 5.0599 7.29449 3.6499 9.23449C2.2299 11.1845 1.7099 13.5645 2.1599 15.9445C2.8099 19.3845 5.5599 22.1345 9.0099 22.7845C9.5599 22.8945 10.1099 22.9445 10.6599 22.9445C12.4699 22.9445 14.2199 22.3845 15.7099 21.2945C17.6499 19.8845 18.9399 17.7245 19.2399 15.3745C19.2899 14.9845 19.1699 14.5945 18.9099 14.3045Z",
    fill: "#4B4AD5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogsColored);
export default __webpack_public_path__ + "static/media/logs-colored.e551cbf63a95ef6ce22b89792b8f4c30.svg";
export { ForwardRef as ReactComponent };